import React from 'react';

import './menu.scss';

const TopMenu = ({children}) => {

    return (
        <div className="top-menu">
            {children}
        </div>
    );
};

export default TopMenu;
